export default __webpack_public_path__ + "static/media/cobrand-header.12ec95ae.svg";